import { LegalPage } from '@/components/LegalPage';

export function AccessibilityPage() {
  return (
    <LegalPage
      title="Accessibility"
      updated="June 18, 2026"
      intro="We want everyone to be able to enjoy BingeBox. Accessibility is part of how we build."
    >
      <h2>What we do</h2>
      <ul>
        <li>Keyboard navigation and visible focus states throughout the site.</li>
        <li>Semantic markup and ARIA labels for screen-reader users.</li>
        <li>A dark, high-contrast theme designed for readability.</li>
        <li>Respect for "reduce motion" — animations are minimized when your system requests it.</li>
        <li>Japanese and English audio on every show; subtitle/caption support in the player.</li>
      </ul>

      <h2>Still improving</h2>
      <p>
        Accessibility is ongoing. We're continuing to improve captions, audio descriptions, and
        screen-reader coverage as the catalog grows.
      </p>

      <h2>Tell us</h2>
      <p>
        Hit a barrier? Please email <a href="mailto:support@gobingebox.com">support@gobingebox.com</a>{' '}
        with the page and what happened — accessibility reports go to the top of the list.
      </p>
    </LegalPage>
  );
}
